
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement(
		"g",
		{ fill: "#89664c" },
		React.createElement("path", { d: "m2.1 19.6c-1 2.7 3.6 12.1 7.7 13.2 8.8 2.3 22.1-4 22.1-4s-11.2-5.1-15.4-6.6c-10.8-4.1-13.7-4.3-14.4-2.6" }),
		React.createElement("path", { d: "m61.9 19.6c1 2.7-3.6 12.1-7.7 13.2-8.8 2.3-22.1-4-22.1-4s11.2-5.1 15.4-6.6c10.8-4.1 13.7-4.3 14.4-2.6" })
	),
	React.createElement("path", { d: "m55 39c0 12.7-10.3 23-23 23-12.7 0-23-10.3-23-23 0-12.7 10.3-23 23-23 12.7 0 23 10.3 23 23", fill: "#ffdd67" }),
	React.createElement("path", { d: "m44.1 11.5c-2.1-3.1.3-4.8-1.4-7.6-1-1.8-2-2.6-3.5-1.2-2.4 2.5-5.2 3.5-7.2 3.5-2 0-4.8-1-7.2-3.5-1.5-1.5-2.4-.6-3.5 1.2-1.7 2.8.7 4.5-1.4 7.6-1.3 1.9-2.6 9.3-2.6 9.3l14.7 2.9 14.7-2.9c0 0-1.3-7.4-2.6-9.3", fill: "#d3976e" }),
	React.createElement("path", { d: "m22.4 5.9c0 0 4.5 3 4.4 4.6-.1 1.8-5.6 5-5.6 5s2.5-3.9 2.6-5.3c.1-1.2-1.4-4.3-1.4-4.3", fill: "#fed0ac" }),
	React.createElement("path", { d: "m41.6 5.9c0 0-4.5 3-4.4 4.6.1 1.8 5.6 5 5.6 5s-2.5-3.9-2.6-5.3c-.1-1.2 1.4-4.3 1.4-4.3", fill: "#89664c" }),
	React.createElement("path", { d: "m47 20.3c-8.6 2.2-15 2.2-15 2.2s-6.4 0-15-2.2l-.7 2.1 15.7 3.6 15.7-3.6-.7-2.1", fill: "#3e4347" }),
	React.createElement("path", { d: "m32 25c0 0-7.4.2-20.7-4.6 0 0 5.1 3.8 7.8 7 5.1 6.2 20.8 6.2 25.9 0 2.6-3.2 7.8-7 7.8-7-13.4 4.8-20.8 4.6-20.8 4.6", fill: "#d3976e" }),
	React.createElement(
		"g",
		{ fill: "#664e27" },
		React.createElement("path", { d: "m39.6 47.9c-4.9 3.6-10.4 3.6-15.3 0-.6-.4-1.1.3-.7 1 1.5 2.6 4.5 4.9 8.4 4.9 3.9 0 6.9-2.3 8.4-4.9.4-.7-.2-1.4-.8-1" }),
		React.createElement("circle", { cx: "23.2", cy: "36.9", r: "3.8" }),
		React.createElement("circle", { cx: "40.8", cy: "36.9", r: "3.8" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/cowboy.js
// module id = 689
// module chunks = 0